<template>
    <ModalComponent
        name="descargar-plazos"
        title="Descargar listado de plazos"
        v-on:close="() => close(false)"
    >
        <template v-if="! descarga_solicitada">            
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <Button @click="descargarExcel()">DESCARGAR</Button>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="card m-0">
                <div class="card-body">                    
                    <div class="row">
                        <h2>Se esta generando el informe, recibirá una notificación para poder descargarlo cuando esté listo.</h2>
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['filters', 'tipo'],
    data() {
        return {
            loading: false,
            descarga_solicitada: false
        }
    },
    methods: {
        close() {
            this.$emit('close', 'descargar-plazos');
        },
        descargarExcel() {
            this.loading = true;
            let filtros = this.filters;

            filtros.tipo = this.tipo;

            let params = {
                filters: filtros,
                lista_id: this.lista.id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.lista.plazos.descargar-excel'), params).then(res => {
                this.descarga_solicitada = true;
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    computed: {
        lista() {
            return this.$store.getters.getListaActiva;
        }
    },
    components: {
        ModalComponent
    }
}
</script>
